import { HistoryDb } from '~/assets/ts/items/dao/historyDb'

export class ItemHistory {
  indexDb: HistoryDb
  maxItems: number

  constructor() {
    this.indexDb = new HistoryDb()
    this.maxItems = 30
  }

  add(setSlug: string) {
    if (process.client && typeof window !== 'undefined') {
      const setIdParts: string[] = setSlug.split('_')[0].split('-')

      this.indexDb.openDb().then(() => {
        this.indexDb.reduce(this.maxItems).then(() => {
          this.indexDb
            .put({
              baseSet: setIdParts[0].toUpperCase() + '-' + setIdParts[1],
              set: setIdParts.join('-'),
              slug: setSlug,
              timestamp: Date.now(),
            })
            .then(() => {})
        })
      })
    }
  }

  getList() {
    return new Promise((resolve) => {
      if (process.client && typeof window !== 'undefined') {
        this.indexDb.openDb().then(() => {
          this.indexDb.getAll().then((result) => {
            resolve(result as { [key: string]: string }[])
          })
        })
      } else {
        resolve(false)
      }
    })
  }
}
